import{match}from"ts-pattern";import{parseChildren}from"./parse-children.js";// https://github.com/microsoft/TypeScript/issues/42873#issuecomment-2065572017
export function matchChildren(children){return match(parseChildren(children)?.kind)}
//# sourceMappingURL=match-children.js.map